import { Injectable } from '@angular/core';

import { Agent, Id } from '../data';
import { AgentFactoryInterface, AgentInterface, IdInterface } from '../../../core';

@Injectable()
export class AgentFactory implements AgentFactoryInterface {
    build(code: IdInterface): AgentInterface {
        const agent = new Agent();
        agent.code = code as Id;

        return agent;
    }
}
